angular.module('populationioApp').service('HelloWords',
	function(){
		'use strict';
		return [
			{
				'abbreviation': 'AD',
				'language': 'Andorra',
				'greeting': 'Hola',
				'probability': 0.000
			},
			{
				'abbreviation': 'AE',
				'language': 'United Arab Emirates',
				'greeting': 'Marhaba',
				'probability': 0.091
			},
			{
				'abbreviation': 'AF',
				'language': 'Afghanistan',
				'greeting': 'Senga yai',
				'probability': 0.739
			},
			{
				'abbreviation': 'AG',
				'language': 'Antigua and Barbuda',
				'greeting': 'Hello',
				'probability': 0.001
			},
			{
				'abbreviation': 'AI',
				'language': 'Anguilla',
				'greeting': 'Hello',
				'probability': 0.000
			},
			{
				'abbreviation': 'AL',
				'language': 'Albania',
				'greeting': 'Tungjatjeta',
				'probability': 0.030
			},
			{
				'abbreviation': 'AM',
				'language': 'Armenia',
				'greeting': 'Barev',
				'probability': 0.028
			},
			{
				'abbreviation': 'AN',
				'language': 'Netherlands Antilles',
				'greeting': 'Kon ta bai',
				'probability': 0.000
			},
			{
				'abbreviation': 'AO',
				'language': 'Angola',
				'greeting': 'Olá',
				'probability': 0.705
			},
			{
				'abbreviation': 'AP',
				'language': 'Asia/Pacific Region',
				'greeting': 'Hello',
				'probability': 0.000
			},
			{
				'abbreviation': 'AQ',
				'language': 'Antarctica',
				'greeting': 'Hello',
				'probability': 0.000
			},
			{
				'abbreviation': 'AR',
				'language': 'Argentina',
				'greeting': 'Hola',
				'probability': 0.497
			},
			{
				'abbreviation': 'AS',
				'language': 'American Samoa',
				'greeting': 'Hello',
				'probability': 0.000
			},
			{
				'abbreviation': 'AT',
				'language': 'Austria',
				'greeting': 'Hallo',
				'probability': 0.059
			},
			{
				'abbreviation': 'AU',
				'language': 'Australia',
				'greeting': 'Hello',
				'probability': 0.225
			},
			{
				'abbreviation': 'AW',
				'language': 'Aruba',
				'greeting': 'Kon ta bai',
				'probability': 0.001
			},
			{
				'abbreviation': 'AX',
				'language': 'Aland Islands',
				'greeting': 'Hello',
				'probability': 0.000
			},
			{
				'abbreviation': 'AZ',
				'language': 'Azerbaijan',
				'greeting': 'Salam',
				'probability': 0.117
			},
			{
				'abbreviation': 'BA',
				'language': 'Bosnia and Herzegovina',
				'greeting': 'Zdravo',
				'probability': 0.025
			},
			{
				'abbreviation': 'BB',
				'language': 'Barbados',
				'greeting': 'Hello',
				'probability': 0.003
			},
			{
				'abbreviation': 'BD',
				'language': 'Bangladesh',
				'greeting': 'Namaskar',
				'probability': 2.229
			},
			{
				'abbreviation': 'BE',
				'language': 'Belgium',
				'greeting': 'Hallo',
				'probability': 0.093
			},
			{
				'abbreviation': 'BF',
				'language': 'Burkina Faso',
				'greeting': 'Bonjour',
				'probability': 0.513
			},
			{
				'abbreviation': 'BG',
				'language': 'Bulgaria',
				'greeting': 'Zdravei',
				'probability': 0.049
			},
			{
				'abbreviation': 'BH',
				'language': 'Bahrain',
				'greeting': 'Marhaba',
				'probability': 0.014
			},
			{
				'abbreviation': 'BI',
				'language': 'Burundi',
				'greeting': 'Bonjour',
				'probability': 0.341
			},
			{
				'abbreviation': 'BJ',
				'language': 'Benin',
				'greeting': 'Bonjour',
				'probability': 0.278
			},
			{
				'abbreviation': 'BM',
				'language': 'Bermuda',
				'greeting': 'Hello',
				'probability': 0.000
			},
			{
				'abbreviation': 'BN',
				'language': 'Brunei Darussalam',
				'greeting': 'Selamat',
				'probability': 0.005
			},
			{
				'abbreviation': 'BO',
				'language': 'Bolivia',
				'greeting': 'Hola',
				'probability': 0.200
			},
			{
				'abbreviation': 'BR',
				'language': 'Brazil',
				'greeting': 'Olá',
				'probability': 2.127
			},
			{
				'abbreviation': 'BS',
				'language': 'Bahamas',
				'greeting': 'Hello',
				'probability': 0.004
			},
			{
				'abbreviation': 'BT',
				'language': 'Bhutan',
				'greeting': 'Kuzu zangpo',
				'probability': 0.010
			},
			{
				'abbreviation': 'BV',
				'language': 'Bouvet Island',
				'greeting': 'Hello',
				'probability': 0.000
			},
			{
				'abbreviation': 'BW',
				'language': 'Botswana',
				'greeting': 'Dumela',
				'probability': 0.034
			},
			{
				'abbreviation': 'BY',
				'language': 'Belarus',
				'greeting': 'Вітаю',
				'probability': 0.072
			},
			{
				'abbreviation': 'BZ',
				'language': 'Belize',
				'greeting': 'Hello',
				'probability': 0.006
			},
			{
				'abbreviation': 'CA',
				'language': 'Canada',
				'greeting': 'Hello',
				'probability': 0.291
			},
			{
				'abbreviation': 'XK',
				'language': 'Kosovo',
				'greeting': 'Përshëndetje',
				'probability': 0.001
			},
			{
				'abbreviation': 'CD',
				'language': 'Congo  The Democratic Republic of the',
				'greeting': 'Bonjour',
				'probability': 2.146
			},
			{
				'abbreviation': 'CF',
				'language': 'Central African Republic',
				'greeting': 'Bonjour',
				'probability': 0.116
			},
			{
				'abbreviation': 'CG',
				'language': 'Congo',
				'greeting': 'Bonjour',
				'probability': 0.123
			},
			{
				'abbreviation': 'CH',
				'language': 'Switzerland',
				'greeting': 'Hallo',
				'probability': 0.063
			},
			{
				'abbreviation': 'CI',
				'language': 'Cote d\'Ivoire',
				'greeting': 'Bonjour',
				'probability': 0.551
			},
			{
				'abbreviation': 'CK',
				'language': 'Cook Islands',
				'greeting': 'Kia orana',
				'probability': 0.000
			},
			{
				'abbreviation': 'CL',
				'language': 'Chile',
				'greeting': 'Hola',
				'probability': 0.176
			},
			{
				'abbreviation': 'CM',
				'language': 'Cameroon',
				'greeting': 'Hello',
				'probability': 0.611
			},
			{
				'abbreviation': 'CN',
				'language': 'China',
				'greeting': '你好',
				'probability': 13.016
			},
			{
				'abbreviation': 'CO',
				'language': 'Colombia',
				'greeting': 'Hola',
				'probability': 0.645
			},
			{
				'abbreviation': 'CR',
				'language': 'Costa Rica',
				'greeting': 'Hola',
				'probability': 0.053
			},
			{
				'abbreviation': 'CU',
				'language': 'Cuba',
				'greeting': 'Hola',
				'probability': 0.075
			},
			{
				'abbreviation': 'CW',
				'language': 'Curacao',
				'greeting': 'Con ta bai',
				'probability': 0.001
			},
			{
				'abbreviation': 'CY',
				'language': 'Cyprus',
				'greeting': 'γεια σας',
				'probability': 0.010
			},
			{
				'abbreviation': 'CV',
				'language': 'Cape Verde',
				'greeting': 'Olá',
				'probability': 0.007
			},
			{
				'abbreviation': 'CZ',
				'language': 'Czech Republic',
				'greeting': 'Dobrý den',
				'probability': 0.085
			},
			{
				'abbreviation': 'DE',
				'language': 'Germany',
				'greeting': 'Hallo',
				'probability': 0.507
			},
			{
				'abbreviation': 'DJ',
				'language': 'Djibouti',
				'greeting': 'Marhaba',
				'probability': 0.017
			},
			{
				'abbreviation': 'DK',
				'language': 'Denmark',
				'greeting': 'Hej',
				'probability': 0.046
			},
			{
				'abbreviation': 'DM',
				'language': 'Dominica',
				'greeting': 'Hello',
				'probability': 0.000
			},
			{
				'abbreviation': 'DO',
				'language': 'Dominican Republic',
				'greeting': 'Hola',
				'probability': 0.154
			},
			{
				'abbreviation': 'KP',
				'language': 'Dem Peoples Rep of Korea',
				'greeting': '안녕하세요',
				'probability': 0.259
			},
			{
				'abbreviation': 'DZ',
				'language': 'Algeria',
				'greeting': 'Marhaba',
				'probability': 0.678
			},
			{
				'abbreviation': 'EC',
				'language': 'Ecuador',
				'greeting': 'Hola',
				'probability': 0.235
			},
			{
				'abbreviation': 'EE',
				'language': 'Estonia',
				'greeting': 'Tervist',
				'probability': 0.010
			},
			{
				'abbreviation': 'EG',
				'language': 'Egypt',
				'greeting': 'Marhaba',
				'probability': 1.364
			},
			{
				'abbreviation': 'ER',
				'language': 'Eritrea',
				'greeting': 'Marhaba',
				'probability': 0.171
			},
			{
				'abbreviation': 'ES',
				'language': 'Spain',
				'greeting': 'Hola',
				'probability': 0.340
			},
			{
				'abbreviation': 'ET',
				'language': 'Ethiopia',
				'greeting': 'Teanastëllën',
				'probability': 2.277
			},
			{
				'abbreviation': 'EU',
				'language': 'Europe',
				'greeting': 'Hello',
				'probability': 0.000
			},
			{
				'abbreviation': 'FI',
				'language': 'Finland',
				'greeting': 'Moi',
				'probability': 0.044
			},
			{
				'abbreviation': 'FJ',
				'language': 'Fiji',
				'greeting': 'Hello',
				'probability': 0.013
			},
			{
				'abbreviation': 'FK',
				'language': 'Falkland Islands (Malvinas)',
				'greeting': 'Hello',
				'probability': 0.000
			},
			{
				'abbreviation': 'MKD',
				'language': 'FYR Macedonia',
				'greeting': 'Zdravo',
				'probability': 0.016
			},
			{
				'abbreviation': 'FM',
				'language': 'Micronesia  Federated States of',
				'greeting': 'Hello',
				'probability': 0.002
			},
			{
				'abbreviation': 'FO',
				'language': 'Faroe Islands',
				'greeting': 'Hallo',
				'probability': 0.000
			},
			{
				'abbreviation': 'FR',
				'language': 'France',
				'greeting': 'Bonjour',
				'probability': 0.570
			},
			{
				'abbreviation': 'GA',
				'language': 'Gabon',
				'greeting': 'Bonjour',
				'probability': 0.039
			},
			{
				'abbreviation': 'GB',
				'language': 'Great Britain',
				'greeting': 'Hello',
				'probability': 0.000
			},
			{
				'abbreviation': 'GD',
				'language': 'Grenada',
				'greeting': 'Hello',
				'probability': 0.001
			},
			{
				'abbreviation': 'GR',
				'language': 'Greece',
				'greeting': 'γεια σας',
				'probability': 0.076
			},
			{
				'abbreviation': 'GE',
				'language': 'Georgia',
				'greeting': 'Gamardjobat',
				'probability': 0.040
			},
			{
				'abbreviation': 'GF',
				'language': 'French Guiana',
				'greeting': 'Bonjour',
				'probability': 0.004
			},
			{
				'abbreviation': 'GG',
				'language': 'Guernsey',
				'greeting': 'Hello',
				'probability': 0.000
			},
			{
				'abbreviation': 'GH',
				'language': 'Ghana',
				'greeting': 'Hello',
				'probability': 0.580
			},
			{
				'abbreviation': 'GI',
				'language': 'Gibraltar',
				'greeting': 'Hello',
				'probability': 0.000
			},
			{
				'abbreviation': 'GL',
				'language': 'Greenland',
				'greeting': 'Aluu',
				'probability': 0.000
			},
			{
				'abbreviation': 'GM',
				'language': 'Gambia',
				'greeting': 'Hello',
				'probability': 0.060
			},
			{
				'abbreviation': 'GN',
				'language': 'Guinea',
				'greeting': 'Bonjour',
				'probability': 0.320
			},
			{
				'abbreviation': 'GP',
				'language': 'Guadeloupe',
				'greeting': 'Hello',
				'probability': 0.004
			},
			{
				'abbreviation': 'GQ',
				'language': 'Equatorial Guinea',
				'greeting': 'Hola',
				'probability': 0.020
			},
			{
				'abbreviation': 'GT',
				'language': 'Guatemala',
				'greeting': 'Hola',
				'probability': 0.353
			},
			{
				'abbreviation': 'GU',
				'language': 'Guam',
				'greeting': 'Hello',
				'probability': 0.002
			},
			{
				'abbreviation': 'GW',
				'language': 'Guinea-Bissau',
				'greeting': 'Olá',
				'probability': 0.047
			},
			{
				'abbreviation': 'GY',
				'language': 'Guyana',
				'greeting': 'Hello',
				'probability': 0.011
			},
			{
				'abbreviation': 'HN',
				'language': 'Honduras',
				'greeting': 'HHola',
				'probability': 0.152
			},
			{
				'abbreviation': 'HR',
				'language': 'Croatia',
				'greeting': 'Bok',
				'probability': 0.029
			},
			{
				'abbreviation': 'HT',
				'language': 'Haiti',
				'greeting': 'Bonjour',
				'probability': 0.190
			},
			{
				'abbreviation': 'HU',
				'language': 'Hungary',
				'greeting': 'Jó napot',
				'probability': 0.070
			},
			{
				'abbreviation': 'HK',
				'language': 'Hong Kong SAR-China',
				'greeting': '你好',
				'probability': 0.049
			},
			{
				'abbreviation': 'IN',
				'language': 'India',
				'greeting': 'नमस्ते',
				'probability': 18.253
			},
			{
				'abbreviation': 'ID',
				'language': 'Indonesia',
				'greeting': 'Selamat',
				'probability': 3.311
			},
			{
				'abbreviation': 'IE',
				'language': 'Ireland',
				'greeting': 'Haileo',
				'probability': 0.051
			},
			{
				'abbreviation': 'IL',
				'language': 'Israel',
				'greeting': 'Shalom',
				'probability': 0.112
			},
			{
				'abbreviation': 'IM',
				'language': 'Isle of Man',
				'greeting': 'Hello',
				'probability': 0.000
			},
			{
				'abbreviation': 'IO',
				'language': 'British Indian Ocean Territory',
				'greeting': 'Hello',
				'probability': 0.000
			},
			{
				'abbreviation': 'IQ',
				'language': 'Iraq',
				'greeting': 'Marhaba',
				'probability': 0.778
			},
			{
				'abbreviation': 'IR',
				'language': 'Islamic Republic of Iran',
				'greeting': 'Salâm',
				'probability': 1.030
			},
			{
				'abbreviation': 'IS',
				'language': 'Iceland',
				'greeting': 'Góðan daginn',
				'probability': 0.003
			},
			{
				'abbreviation': 'IT',
				'language': 'Italy',
				'greeting': 'Buon giorno',
				'probability': 0.396
			},
			{
				'abbreviation': 'JE',
				'language': 'Jersey',
				'greeting': 'Hello',
				'probability': 0.000
			},
			{
				'abbreviation': 'JM',
				'language': 'Jamaica',
				'greeting': 'Hello',
				'probability': 0.036
			},
			{
				'abbreviation': 'JP',
				'language': 'Japan',
				'greeting': 'こんにちは',
				'probability': 0.748
			},
			{
				'abbreviation': 'JO',
				'language': 'Jordan',
				'greeting': 'Marhaba',
				'probability': 0.139
			},
			{
				'abbreviation': 'KE',
				'language': 'Kenya',
				'greeting': 'Habari',
				'probability': 1.134
			},
			{
				'abbreviation': 'KG',
				'language': 'Kyrgyz Republic',
				'greeting': 'Kandisiz',
				'probability': 0.109
			},
			{
				'abbreviation': 'KH',
				'language': 'Cambodia',
				'greeting': 'Sua s\'dei',
				'probability': 0.280
			},
			{
				'abbreviation': 'KI',
				'language': 'Kiribati',
				'greeting': 'Mauri',
				'probability': 0.002
			},
			{
				'abbreviation': 'KM',
				'language': 'Comoros',
				'greeting': 'Bariza djioni',
				'probability': 0.019
			},
			{
				'abbreviation': 'KN',
				'language': 'Saint Kitts and Nevis',
				'greeting': 'Hello',
				'probability': 0.000
			},
			{
				'abbreviation': 'KW',
				'language': 'Kuwait',
				'greeting': 'Marhaba',
				'probability': 0.051
			},
			{
				'abbreviation': 'KY',
				'language': 'Cayman Islands',
				'greeting': 'Hello',
				'probability': 0.000
			},
			{
				'abbreviation': 'KZ',
				'language': 'Kazakhstan',
				'greeting': 'Salam',
				'probability': 0.237
			},
			{
				'abbreviation': 'LA',
				'language': 'Lao People\'s Democratic Republic',
				'greeting': 'Sabaidee',
				'probability': 0.130
			},
			{
				'abbreviation': 'LB',
				'language': 'Lebanon',
				'greeting': 'Marhaba',
				'probability': 0.048
			},
			{
				'abbreviation': 'LC',
				'language': 'Saint Lucia',
				'greeting': 'Hello',
				'probability': 0.002
			},
			{
				'abbreviation': 'LI',
				'language': 'Liechtenstein',
				'greeting': 'Hallo',
				'probability': 0.000
			},
			{
				'abbreviation': 'LK',
				'language': 'Sri Lanka',
				'greeting': 'A`yubowan',
				'probability': 0.267
			},
			{
				'abbreviation': 'LR',
				'language': 'Liberia',
				'greeting': 'Hello',
				'probability': 0.112
			},
			{
				'abbreviation': 'LS',
				'language': 'Lesotho',
				'greeting': 'Hello',
				'probability': 0.041
			},
			{
				'abbreviation': 'LT',
				'language': 'Lithuania',
				'greeting': 'Laba diena',
				'probability': 0.025
			},
			{
				'abbreviation': 'LU',
				'language': 'Luxembourg',
				'greeting': 'Moïen',
				'probability': 0.005
			},
			{
				'abbreviation': 'LV',
				'language': 'Latvia',
				'greeting': 'Sveiki',
				'probability': 0.016
			},
			{
				'abbreviation': 'LY',
				'language': 'Libyan Arab Jamahiriya',
				'greeting': 'Marhaba',
				'probability': 0.090
			},
			{
				'abbreviation': 'MO',
				'language': 'Macao SAR China',
				'greeting': '你好',
				'probability': 0.004
			},
			{
				'abbreviation': 'MA',
				'language': 'Morocco',
				'greeting': 'Marhaba',
				'probability': 0.537
			},
			{
				'abbreviation': 'MC',
				'language': 'Monaco',
				'greeting': 'Bonjour',
				'probability': 0.000
			},
			{
				'abbreviation': 'MD',
				'language': 'Moldova  Republic of',
				'greeting': 'Salut',
				'probability': 0.029
			},
			{
				'abbreviation': 'ME',
				'language': 'Montenegro',
				'greeting': 'Zdravo',
				'probability': 0.005
			},
			{
				'abbreviation': 'MG',
				'language': 'Madagascar',
				'greeting': 'Manao ahoana',
				'probability': 0.596
			},
			{
				'abbreviation': 'MH',
				'language': 'Marshall Islands',
				'greeting': 'Yokwe',
				'probability': 0.000
			},
			{
				'abbreviation': 'ML',
				'language': 'Mali',
				'greeting': 'Bonjour',
				'probability': 0.546
			},
			{
				'abbreviation': 'MM',
				'language': 'Myanmar',
				'greeting': 'Mingalarba',
				'probability': 0.649
			},
			{
				'abbreviation': 'MN',
				'language': 'Mongolia',
				'greeting': 'Sain baina uu',
				'probability': 0.046
			},
			{
				'abbreviation': 'MP',
				'language': 'Northern Mariana Islands',
				'greeting': 'Hello',
				'probability': 0.000
			},
			{
				'abbreviation': 'MQ',
				'language': 'Martinique',
				'greeting': 'Hello',
				'probability': 0.003
			},
			{
				'abbreviation': 'MR',
				'language': 'Mauritania',
				'greeting': 'Marhaba',
				'probability': 0.098
			},
			{
				'abbreviation': 'MS',
				'language': 'Montserrat',
				'greeting': 'Hello',
				'probability': 0.000
			},
			{
				'abbreviation': 'MT',
				'language': 'Malta',
				'greeting': 'Bongu',
				'probability': 0.003
			},
			{
				'abbreviation': 'MU',
				'language': 'Mauritius',
				'greeting': 'Hello',
				'probability': 0.010
			},
			{
				'abbreviation': 'MV',
				'language': 'Maldives',
				'greeting': 'Kihineth',
				'probability': 0.005
			},
			{
				'abbreviation': 'MW',
				'language': 'Malawi',
				'greeting': 'Muribwanji',
				'probability': 0.487
			},
			{
				'abbreviation': 'MX',
				'language': 'Mexico',
				'greeting': 'Hola',
				'probability': 1.594
			},
			{
				'abbreviation': 'MY',
				'language': 'Malaysia',
				'greeting': 'Selamat',
				'probability': 0.387
			},
			{
				'abbreviation': 'MZ',
				'language': 'Mozambique',
				'greeting': 'Olá',
				'probability': 0.740
			},
			{
				'abbreviation': 'NA',
				'language': 'Namibia',
				'greeting': 'Hello',
				'probability': 0.044
			},
			{
				'abbreviation': 'NC',
				'language': 'New Caledonia',
				'greeting': 'Bozo',
				'probability': 0.003
			},
			{
				'abbreviation': 'NE',
				'language': 'Niger',
				'greeting': 'Bonjour',
				'probability': 0.685
			},
			{
				'abbreviation': 'NF',
				'language': 'Norfolk Island',
				'greeting': 'Whataway',
				'probability': 0.000
			},
			{
				'abbreviation': 'NG',
				'language': 'Nigeria',
				'greeting': 'Hello',
				'probability': 5.344
			},
			{
				'abbreviation': 'NI',
				'language': 'Nicaragua',
				'greeting': 'Hola',
				'probability': 0.098
			},
			{
				'abbreviation': 'NL',
				'language': 'Netherlands',
				'greeting': 'Hallo',
				'probability': 0.129
			},
			{
				'abbreviation': 'NO',
				'language': 'Norway',
				'greeting': 'Hallo',
				'probability': 0.046
			},
			{
				'abbreviation': 'NP',
				'language': 'Nepal',
				'greeting': 'Namaste',
				'probability': 0.412
			},
			{
				'abbreviation': 'NR',
				'language': 'Nauru',
				'greeting': 'Hello',
				'probability': 0.000
			},
			{
				'abbreviation': 'NU',
				'language': 'Niue',
				'greeting': 'Faka lofa lahi atu',
				'probability': 0.000
			},
			{
				'abbreviation': 'NZ',
				'language': 'New Zealand',
				'greeting': 'Hello',
				'probability': 0.045
			},
			{
				'abbreviation': 'OM',
				'language': 'Oman',
				'greeting': 'Marhaba',
				'probability': 0.054
			},
			{
				'abbreviation': 'PA',
				'language': 'Panama',
				'greeting': 'Hola',
				'probability': 0.054
			},
			{
				'abbreviation': 'PE',
				'language': 'Peru',
				'greeting': 'Hola',
				'probability': 0.429
			},
			{
				'abbreviation': 'PF',
				'language': 'French Polynesia',
				'greeting': 'Bonjour',
				'probability': 0.003
			},
			{
				'abbreviation': 'PG',
				'language': 'Papua New Guinea',
				'greeting': 'Hello',
				'probability': 0.154
			},
			{
				'abbreviation': 'PH',
				'language': 'Philippines',
				'greeting': 'Halo',
				'probability': 1.755
			},
			{
				'abbreviation': 'PK',
				'language': 'Pakistan',
				'greeting': 'Adaab',
				'probability': 3.302
			},
			{
				'abbreviation': 'PL',
				'language': 'Poland',
				'greeting': 'Dzień dobry',
				'probability': 0.296
			},
			{
				'abbreviation': 'PM',
				'language': 'Saint Pierre and Miquelon',
				'greeting': 'Hello',
				'probability': 0.000
			},
			{
				'abbreviation': 'PR',
				'language': 'Puerto Rico',
				'greeting': 'Hola',
				'probability': 0.031
			},
			{
				'abbreviation': 'PS',
				'language': 'Palestinian Territory',
				'greeting': 'Marhaba',
				'probability': 0.000
			},
			{
				'abbreviation': 'PT',
				'language': 'Portugal',
				'greeting': 'Olá',
				'probability': 0.064
			},
			{
				'abbreviation': 'PW',
				'language': 'Palau',
				'greeting': 'Alii',
				'probability': 0.000
			},
			{
				'abbreviation': 'PY',
				'language': 'Paraguay',
				'greeting': 'Hola',
				'probability': 0.118
			},
			{
				'abbreviation': 'QA',
				'language': 'Qatar',
				'greeting': 'Marhaba',
				'probability': 0.017
			},
			{
				'abbreviation': 'RE',
				'language': 'Reunion',
				'greeting': 'Hello',
				'probability': 0.010
			},
			{
				'abbreviation': 'KR',
				'language': 'Rep of Korea',
				'greeting': '안녕하세요',
				'probability': 0.341
			},
			{
				'abbreviation': 'RO',
				'language': 'Romania',
				'greeting': 'Salut',
				'probability': 0.158
			},
			{
				'abbreviation': 'RS',
				'language': 'Serbia',
				'greeting': 'Zdravo',
				'probability': 0.065
			},
			{
				'abbreviation': 'RU',
				'language': 'Russian Federation',
				'greeting': 'Привет',
				'probability': 1.193
			},
			{
				'abbreviation': 'RW',
				'language': 'Rwanda',
				'greeting': 'Hello',
				'probability': 0.303
			},
			{
				'abbreviation': 'SA',
				'language': 'Saudi Arabia',
				'greeting': 'Marhaba',
				'probability': 0.396
			},
			{
				'abbreviation': 'SB',
				'language': 'Solomon Islands',
				'greeting': 'Hello',
				'probability': 0.012
			},
			{
				'abbreviation': 'SC',
				'language': 'Seychelles',
				'greeting': 'Hello',
				'probability': 0.001
			},
			{
				'abbreviation': 'SS',
				'language': 'South Sudan',
				'greeting': 'Hello',
				'probability': 0.306
			},
			{
				'abbreviation': 'SD',
				'language': 'Sudan',
				'greeting': 'Marhaba',
				'probability': 0.934
			},
			{
				'abbreviation': 'SE',
				'language': 'Sweden',
				'greeting': 'God dag',
				'probability': 0.084
			},
			{
				'abbreviation': 'SG',
				'language': 'Singapore',
				'greeting': 'Selamat',
				'probability': 0.040
			},
			{
				'abbreviation': 'SI',
				'language': 'Slovenia',
				'greeting': 'Živijo',
				'probability': 0.015
			},
			{
				'abbreviation': 'SK',
				'language': 'Slovak Republic',
				'greeting': 'Dobrý deň',
				'probability': 0.042
			},
			{
				'abbreviation': 'SL',
				'language': 'Sierra Leone',
				'greeting': 'Hello',
				'probability': 0.161
			},
			{
				'abbreviation': 'SM',
				'language': 'San Marino',
				'greeting': 'Buon giorno',
				'probability': 0.000
			},
			{
				'abbreviation': 'SN',
				'language': 'Senegal',
				'greeting': 'Bonjour',
				'probability': 0.396
			},
			{
				'abbreviation': 'SO',
				'language': 'Somalia',
				'greeting': 'Maalim wanaqsan',
				'probability': 0.344
			},
			{
				'abbreviation': 'SR',
				'language': 'Suriname',
				'greeting': 'Hallo',
				'probability': 0.007
			},
			{
				'abbreviation': 'ST',
				'language': 'Sao Tome and Principe',
				'greeting': 'Hello',
				'probability': 0.005
			},
			{
				'abbreviation': 'SV',
				'language': 'El Salvador',
				'greeting': 'Hola',
				'probability': 0.091
			},
			{
				'abbreviation': 'SY',
				'language': 'Syrian Arab Republic',
				'greeting': 'Marhaba',
				'probability': 0.384
			},
			{
				'abbreviation': 'SZ',
				'language': 'eSwatini',
				'greeting': 'Hello',
				'probability': 0.027
			},
			{
				'abbreviation': 'TC',
				'language': 'Turks and Caicos Islands',
				'greeting': 'Hello',
				'probability': 0.000
			},
			{
				'abbreviation': 'TD',
				'language': 'Chad',
				'greeting': 'Marhaba',
				'probability': 0.439
			},
			{
				'abbreviation': 'TG',
				'language': 'Togo',
				'greeting': 'Bonjour',
				'probability': 0.182
			},
			{
				'abbreviation': 'TH',
				'language': 'Thailand',
				'greeting': 'Sawatdi',
				'probability': 0.474
			},
			{
				'abbreviation': 'TJ',
				'language': 'Tajikistan',
				'greeting': 'Salom',
				'probability': 0.199
			},
			{
				'abbreviation': 'TL',
				'language': 'Timor-Leste',
				'greeting': 'Ola',
				'probability': 0.030
			},
			{
				'abbreviation': 'TK',
				'language': 'Tokelau',
				'greeting': 'Taloha',
				'probability': 0.000
			},
			{
				'abbreviation': 'TM',
				'language': 'Turkmenistan',
				'greeting': 'Salam',
				'probability': 0.080
			},
			{
				'abbreviation': 'TN',
				'language': 'Tunisia',
				'greeting': 'Marhaba',
				'probability': 0.135
			},
			{
				'abbreviation': 'TO',
				'language': 'Tonga',
				'greeting': 'Malo e lelei',
				'probability': 0.002
			},
			{
				'abbreviation': 'TR',
				'language': 'Turkey',
				'greeting': 'Merhaba',
				'probability': 0.893
			},
			{
				'abbreviation': 'TT',
				'language': 'Trinidad and Tobago',
				'greeting': 'Hello',
				'probability': 0.013
			},
			{
				'abbreviation': 'TV',
				'language': 'Tuvalu',
				'greeting': 'Talofa',
				'probability': 0.000
			},
			{
				'abbreviation': 'TZ',
				'language': 'Tanzania  United Republic of',
				'greeting': 'Habari',
				'probability': 1.435
			},
			{
				'abbreviation': 'UA',
				'language': 'Ukraine',
				'greeting': 'Pryvit',
				'probability': 0.343
			},
			{
				'abbreviation': 'UG',
				'language': 'Uganda',
				'greeting': 'Habari',
				'probability': 1.218
			},
			{
				'abbreviation': 'UK',
				'language': 'United Kingdom',
				'greeting': 'Hello',
				'probability': 0.554
			},
			{
				'abbreviation': 'UM',
				'language': 'United States Minor Outlying Islands',
				'greeting': 'Hello',
				'probability': 0.000
			},
			{
				'abbreviation': 'US',
				'language': 'United States',
				'greeting': 'Hello',
				'probability': 3.062
			},
			{
				'abbreviation': 'UY',
				'language': 'Uruguay',
				'greeting': 'Hola',
				'probability': 0.035
			},
			{
				'abbreviation': 'UZ',
				'language': 'Uzbekistan',
				'greeting': 'Salom',
				'probability': 0.443
			},
			{
				'abbreviation': 'VA',
				'language': 'Holy See (Vatican City State)',
				'greeting': 'Buon giorno',
				'probability': 0.000
			},
			{
				'abbreviation': 'VC',
				'language': 'Saint Vincent and the Grenadines',
				'greeting': 'Hello',
				'probability': 0.001
			},
			{
				'abbreviation': 'VE',
				'language': 'Venezuela',
				'greeting': 'Hola',
				'probability': 0.430
			},
			{
				'abbreviation': 'VG',
				'language': 'Virgin Islands  British',
				'greeting': 'Hello',
				'probability': 0.000
			},
			{
				'abbreviation': 'VI',
				'language': 'Virgin Islands  U.S.',
				'greeting': 'Hello',
				'probability': 0.001
			},
			{
				'abbreviation': 'VN',
				'language': 'Vietnam',
				'greeting': 'Chào',
				'probability': 0.997
			},
			{
				'abbreviation': 'VU',
				'language': 'Vanuatu',
				'greeting': 'Halo',
				'probability': 0.005
			},
			{
				'abbreviation': 'WF',
				'language': 'Wallis and Futuna',
				'greeting': 'Malo le kataki',
				'probability': 0.000
			},
			{
				'abbreviation': 'EH',
				'language': 'Western Sahara',
				'greeting': 'Hola',
				'probability': 0.009
			},
			{
				'abbreviation': 'PS',
				'language': 'West Bank and Gaza',
				'greeting': 'Marhaba',
				'probability': 0.098
			},
			{
				'abbreviation': 'WS',
				'language': 'Samoa',
				'greeting': 'Talofa',
				'probability': 0.003
			},
			{
				'abbreviation': 'YE',
				'language': 'Rep of Yemen',
				'greeting': 'Marhaba',
				'probability': 0.555
			},
			{
				'abbreviation': 'YT',
				'language': 'Mayotte',
				'greeting': 'Hello',
				'probability': 0.005
			},
			{
				'abbreviation': 'ZA',
				'language': 'South Africa',
				'greeting': 'Hello',
				'probability': 0.780
			},
			{
				'abbreviation': 'ZM',
				'language': 'Zambia',
				'greeting': 'Hello',
				'probability': 0.473
			},
			{
				'abbreviation': 'ZW',
				'language': 'Zimbabwe',
				'greeting': 'Hello',
				'probability': 0.329
			}
		];
	}
);
